import {
  ErrorResponse,
  useCustomToast,
} from 'features/auth/hooks/use-custom-toast/use-custom-toast';
import { useGlobalMutation } from 'state/query-client/hooks';
import { ArchivedChatsParams, getArchivedChats, unArchiveChat } from '../services/archive-service';
import { useConfig } from 'hooks/use-config';
import { useTranslation } from 'react-i18next';

export const useGetArchivedChats = () => {
  const { showErrorToast } = useCustomToast();
  const { configurationSettings } = useConfig();

  return useGlobalMutation({
    mutationKey: ['getArchivedChats'],
    mutationFn: (param: ArchivedChatsParams) => getArchivedChats(param, configurationSettings),
    onError: ({ error }: ErrorResponse) => {
      showErrorToast(error);
    },
  });
};

export const useUnArchiveChat = () => {
  const { showErrorToast, showSuccessToast } = useCustomToast();
  const { configurationSettings } = useConfig();
  const { t } = useTranslation();

  return useGlobalMutation({
    mutationKey: ['unArchivedChat'],
    mutationFn: (conversationId: string) => unArchiveChat(conversationId, configurationSettings),
    onError: ({ error }: ErrorResponse) => {
      showErrorToast(error);
    },
    onSuccess: () => {
      showSuccessToast({ title: t('SUCCESS'), description: t('UNARCHIVE_SUCCESS') });
    },
  });
};
